export default {
  "loyaltyAdmin.workspaceAccessRequired": "Мерчант доступен вашей учётной записи, но права на его лояльность не назначены. Администратор должен назначить роль лояльности для этого мерчанта или его owner; затем войдите заново. Права на платежи и финансовые операции назначаются отдельно.",
  "loyaltyAdmin.sourceTitle": "Источник лояльности и Syrve",
  "loyaltyAdmin.sourceScope": "Изменения относятся только к выбранному мерчанту.",
  "loyaltyAdmin.sourcePurpose": "Здесь выбирается, какая система лояльности используется при оплате: Syrve или Coop. Для создания категории и выпуска карты эти настройки заполнять не нужно.",
  "loyaltyAdmin.sourceChangeSettings": "Изменить систему лояльности для оплат",
  "loyaltyAdmin.sourceFinancial": "Финансовый источник лояльности",
  "loyaltyAdmin.sourceSyrveIntegration": "Интеграция лояльности с Syrve",
  "loyaltyAdmin.sourceNative": "Собственная лояльность Coop",
  "loyaltyAdmin.sourceSyrve": "Syrve",
  "loyaltyAdmin.sourceEnabled": "Включена",
  "loyaltyAdmin.sourceDisabled": "Выключена",
  "loyaltyAdmin.sourceSeparateNotice": "Смена источника не отключает интеграцию с Syrve.",
  "loyaltyAdmin.sourceAction": "Изменяемая настройка",
  "loyaltyAdmin.sourceTarget": "Новый финансовый источник",
  "loyaltyAdmin.sourceIntegrationTarget": "Новое состояние интеграции Syrve",
  "loyaltyAdmin.sourceReason": "Причина изменения источника или интеграции",
  "loyaltyAdmin.sourceReconciliation": "Подтверждение сверки и готовности",
  "loyaltyAdmin.sourceRollback": "План отката",
  "loyaltyAdmin.sourceConsequences": "Перед изменением остановите новые операции лояльности, завершите активные визиты и сверьте незавершённые оплаты и остатки. Имеющиеся балансы и история операций сохраняются. Остальные POS-функции не затрагиваются.",
  "loyaltyAdmin.sourceApply": "Применить это административное изменение",
  "loyaltyAdmin.sourceRetry": "Повторить сохранённое административное изменение",
  "loyaltyAdmin.sourceApplied": "Административное изменение подтверждено и записано в журнал.",
  "loyaltyAdmin.sourcePendingWork": "Текущая настройка сохранена. Перед изменением завершите активные визиты и сверьте незавершённые оплаты или операции лояльности.",
  "loyaltyAdmin.sourceNativeUnavailable": "Собственный checkout ещё не готов для настроенных POS-маршрутов. Текущий источник сохранён.",
  "loyaltyAdmin.sourceAdapterRequired": "Перед выбором Syrve финансовым источником включите интеграцию лояльности с Syrve отдельным действием.",
  "loyaltyAdmin.sourceRevisionChanged": "Настройки изменились. Обновите их и проверьте запрошенное изменение заново.",
  "loyaltyAdmin.sourceResultUnknown": "Результат не подтверждён. Повторите ту же сохранённую команду перед новым изменением.",
  "loyaltyAdmin.sourceEditRejected": "Исправить отклонённое изменение",
  "loyaltyAdmin.sourceInvalidSaved": "Не удалось восстановить сохранённое административное изменение. Обратитесь к администратору для проверки результата.",
  "loyaltyAdmin.giftFundingTitle": "Платная Gift card",
  "loyaltyAdmin.giftFundingNotice": "Выберите неоплаченный счёт Gift, примите оплату и проверьте результат.",
  "loyaltyAdmin.giftFundingDisabled": "Платное финансирование Gift недоступно для этого мерчанта.",
  "loyaltyAdmin.giftFundingKind": "Операция Gift",
  "loyaltyAdmin.giftSale": "Выпустить после оплаты",
  "loyaltyAdmin.giftTopup": "Платное пополнение",
  "loyaltyAdmin.giftInvoice": "Счёт на номинал Gift",
  "loyaltyAdmin.giftSelectInvoice": "Выберите неоплаченный счёт",
  "loyaltyAdmin.giftUnnumberedInvoice": "Счёт без номера",
  "loyaltyAdmin.giftSavedInvoice": "Ранее выбранный счёт",
  "loyaltyAdmin.giftRefreshInvoices": "Обновить счета",
  "loyaltyAdmin.giftNoInvoices": "Подходящих неоплаченных счетов нет. Создайте отдельный счёт на номинал Gift в обычном заказе.",
  "loyaltyAdmin.giftReason": "Причина финансирования Gift",
  "loyaltyAdmin.giftPrepare": "Подготовить оплату Gift",
  "loyaltyAdmin.giftRetryPreparation": "Повторить ту же подготовку",
  "loyaltyAdmin.giftAwaitingPayment": "Ожидается полная оплата и выданный чек:",
  "loyaltyAdmin.giftRefreshResult": "Проверить оплату и результат Gift",
  "loyaltyAdmin.giftCancelNotice": "Подготовку можно прекратить только после подтверждения сервером, что оплата не начиналась. Неизвестный банковский результат остаётся в ожидании.",
  "loyaltyAdmin.giftCancelReason": "Причина прекращения подготовки",
  "loyaltyAdmin.giftCancelPreparation": "Прекратить подготовку, если оплата не начиналась",
  "loyaltyAdmin.giftCanceled": "Подготовка прекращена. Номинал Gift не зачислен.",
  "loyaltyAdmin.giftCanceling": "Отмена проверяется. Сохраните эту попытку до подтверждения результата.",
  "loyaltyAdmin.giftCompleted": "Номинал Gift зачислен:",
  "loyaltyAdmin.reservedValue": "Зарезервированная сумма",
  "loyaltyAdmin.giftAvailable": "Доступный номинал:",
  "loyaltyAdmin.giftValueExpires": "Срок этого покупного номинала:",
  "loyaltyAdmin.giftNext": "Начать следующую операцию Gift",
  "loyaltyAdmin.giftRecoverNotice": "Не удалось прочитать сохранённую попытку. Повторите ту же подготовку или проверьте результат; повторно оплату не принимайте.",
  "loyaltyAdmin.giftOperationPending": "Результат не подтверждён. Сохраните эту попытку и проверьте снова. Для повтора пополнения предъявите тот же код карты ещё раз.",
  "loyaltyAdmin.giftInvalidRecovery": "Сохранённые данные Gift не удалось восстановить. Обратитесь к администратору для проверки прежней операции перед созданием новой.",
  "loyaltyAdmin.gift": "Gift card",
  "loyaltyAdmin.giftMonths": "Срок покупного номинала, месяцев",
  "loyaltyAdmin.giftPaidOnly": "Карта выпускается пустой. Номинал добавляется отдельно.",
  "loyaltyAdmin.creditGiftAmount": "Сумма доначисления Gift",
  "loyaltyAdmin.manualGiftCredit": "Доначислить номинал Gift",
  "loyaltyAdmin.giftCredited": "Номинал Gift доначислен",
  "loyaltyAdmin.manualGiftNotice": "Ручное начисление без оплаты.",

  "loyaltyAdmin.systemAuthor": "Система",
  "loyaltyAdmin.workspaceIntro": "Подарочные, накопительные и дисконтные карты",
  "loyaltyAdmin.sessionChanged": "Пользователь изменился. Перезагрузите страницу перед продолжением.",
  "loyaltyAdmin.ownerChanged": "Владелец мерчанта изменился. Перезагрузите страницу и проверьте действующую программу.",
  "loyaltyAdmin.cardQr": "QR-код карты лояльности",
  "loyaltyAdmin.downloadCardQr": "Сохранить QR карты",
  "loyaltyAdmin.findCard": "Найти карту",
  "loyaltyAdmin.cardCode": "Точный код карты",
  "loyaltyAdmin.exactCodeNotice": "Отсканируйте или введите полный код карты.",
  "loyaltyAdmin.scanCard": "Сканировать карту",
  "loyaltyAdmin.closeCamera": "Закрыть камеру",
  "loyaltyAdmin.cameraStarting": "Запуск камеры…",
  "loyaltyAdmin.cameraUnavailable": "Камера недоступна. Разрешите доступ к камере или введите код вручную.",
  "loyaltyAdmin.cardLookupFailed": "Карта не найдена или недоступна. Проверьте мерчанта и точный код.",
  "loyaltyAdmin.recoveryUnavailable": "Доначисления сейчас отключены. Сохранённый запрос оставлен для сверки.",
  "loyaltyAdmin.invalidRecovery": "Сохранённый запрос повреждён или недоступен. Новые доначисления заблокированы до сверки его фактического результата.",
  "loyaltyAdmin.coreFinanceTitle": "Финансы собственных карт",
  "loyaltyAdmin.issuerOnlyNotice": "Здесь доступны только карты, выпущенные этим мерчантом.",
  "loyaltyAdmin.checkResult": "Проверить результат",
  "loyaltyAdmin.cancelPendingCredit": "Отменить непроведённое доначисление",
  "loyaltyAdmin.retryCancel": "Повторить отмену",
  "loyaltyAdmin.cancelledCredit": "Доначисление отменено; баллы не добавлены.",
  "loyaltyAdmin.committedAwaitingCore": "Доначисление проведено. Сверка с Core ещё не завершена; исходный запрос сохранён.",
  "loyaltyAdmin.abortedAwaitingCore": "Отмена зафиксирована. Сверка с Core ещё не завершена.",
  "loyaltyAdmin.pendingCredit": "Операция ещё не завершена. Новый запрос не создан.",
  "loyaltyAdmin.financeUnavailable": "Финансовые данные временно недоступны. Сохранённый запрос можно повторить.",

  "loyaltyAdmin.title": "Карты лояльности",
  "loyaltyAdmin.notice":
    "Эти карты пока недоступны для оплаты. Существующая лояльность Syrve продолжает работать.",
  "loyaltyAdmin.merchant": "Мерчант",
  "loyaltyAdmin.selectMerchant": "Выберите мерчанта",
  "loyaltyAdmin.loadError": "Не удалось загрузить мерчантов.",
  "loyaltyAdmin.disabled":
    "Управление собственной лояльностью ещё не включено в этой среде.",
  "loyaltyAdmin.forbidden": "Нет прав для этой операции.",
  "loyaltyAdmin.changed":
    "Данные изменились. Обновите и проверьте их перед повтором.",
  "loyaltyAdmin.conflict":
    "Этот ключ запроса уже использован для другой операции.",
  "loyaltyAdmin.requestError":
    "Не удалось выполнить запрос. Обновите данные или повторите сохранённый запрос.",
  "loyaltyAdmin.storageRequired":
    "Для безопасного повтора запроса разрешите хранение данных текущей сессии.",
  "loyaltyAdmin.invalid":
    "Проверьте проценты, стоимость балла и срок действия.",
  "loyaltyAdmin.refresh": "Обновить",
  "loyaltyAdmin.uncertain":
    "Результат не подтверждён. Повторите тот же запрос, чтобы не создать дубликат.",
  "loyaltyAdmin.retry": "Повторить сохранённый запрос",
  "loyaltyAdmin.issued": "Карта выпущена",
  "loyaltyAdmin.bearerWarning":
    "Храните номер в безопасности: в режиме предъявителя он даёт право списания. Не публикуйте его.",
  "loyaltyAdmin.hide": "Скрыть номер",
  "loyaltyAdmin.categories": "Категории",
  "loyaltyAdmin.version": "Версия",
  "loyaltyAdmin.edit": "Изменить",
  "loyaltyAdmin.history": "История правил",
  "loyaltyAdmin.reason": "Причина изменения или выпуска",
  "loyaltyAdmin.issueReason": "Причина выпуска карты",
  "loyaltyAdmin.companionCategory": "Вторая категория (необязательно)",
  "loyaltyAdmin.singleCategory": "Без второй категории",
  "loyaltyAdmin.blockReason": "Причина блокировки или разблокировки",
  "loyaltyAdmin.newVersion": "Новая версия правил",
  "loyaltyAdmin.newCategory": "Новая категория",
  "loyaltyAdmin.createCategory": "Создать категорию",
  "loyaltyAdmin.resetCategory": "Очистить форму категории",
  "loyaltyAdmin.reasonRequired": "Укажите причину.",
  "loyaltyAdmin.versionNotice":
    "У выпущенных карт сохраняются исходные правила.",
  "loyaltyAdmin.name": "Название",
  "loyaltyAdmin.kind": "Тип",
  "loyaltyAdmin.accumulation": "Накопительная",
  "loyaltyAdmin.discount": "Дисконтная",
  "loyaltyAdmin.rate": "Ставка, %",
  "loyaltyAdmin.limit": "Лимит оплаты баллами, %",
  "loyaltyAdmin.pointRate": "Стоимость 1 балла",
  "loyaltyAdmin.months": "Срок начисления, месяцы",
  "loyaltyAdmin.confirmation": "Подтверждение списания",
  "loyaltyAdmin.BEARER": "Предъявитель",
  "loyaltyAdmin.PIN": "PIN",
  "loyaltyAdmin.SMS": "SMS",
  "loyaltyAdmin.ACCOUNT": "Кабинет гостя",
  "loyaltyAdmin.DYNAMIC_QR": "Одноразовый QR",
  "loyaltyAdmin.excludeAccrual": "Не начислять за",
  "loyaltyAdmin.excludeDiscount": "Не давать скидку на",
  "loyaltyAdmin.excludeRedemption": "Не оплачивать баллами",
  "loyaltyAdmin.removedCategory":
    "Удалённая категория товаров — проверьте исключение",
  "loyaltyAdmin.save": "Сохранить версию",
  "loyaltyAdmin.issue": "Выпустить карту",
  "loyaltyAdmin.category": "Категория",
  "loyaltyAdmin.selectCategory": "Выберите категорию",
  "loyaltyAdmin.more": "Загрузить ещё",
  "loyaltyAdmin.cards": "Карты",
  "loyaltyAdmin.blocked": "Заблокирована",
  "loyaltyAdmin.active": "Активна",
  "loyaltyAdmin.unblock": "Разблокировать",
  "loyaltyAdmin.block": "Заблокировать",
  "loyaltyAdmin.financeTitle": "Баланс и операции Coop",
  "loyaltyAdmin.selectCard": "Выберите карту",
  "loyaltyAdmin.pendingCard": "Карта с незавершённым запросом",
  "loyaltyAdmin.balance": "Баланс",
  "loyaltyAdmin.available": "Доступно баллов",
  "loyaltyAdmin.reserved": "Зарезервировано баллов",
  "loyaltyAdmin.creditPoints": "Доначислить баллов",
  "loyaltyAdmin.expiryOverride": "Изменить дату сгорания",
  "loyaltyAdmin.expiryHint": "Пустое поле — срок карты. Выбранная дата заканчивается в 23:59 UTC",
  "loyaltyAdmin.monthsUnit": "мес.",
  "loyaltyAdmin.overrideReason": "Причина изменения срока",
  "loyaltyAdmin.manualCredit": "Доначислить баллы",
  "loyaltyAdmin.operations": "Операции",
  "loyaltyAdmin.author": "Автор",
  "loyaltyAdmin.standardExpiry": "Стандартный срок",
  "loyaltyAdmin.selectedExpiry": "Выбранный срок",
  "loyaltyAdmin.credited": "Баллы доначислены",
  "loyaltyAdmin.creditReceiptTitle": "Подтверждённое начисление",
  "loyaltyAdmin.newBalance": "Новый остаток",
  "loyaltyAdmin.minorUnits": "минимальных единиц",
  "loyaltyAdmin.creditReceiptUnavailable": "Начисление подтверждено, но часть точных данных результата не загрузилась. Отсутствующие остаток или срок не вычисляются предположительно.",
  "loyaltyAdmin.retryReceipt": "Загрузить данные результата",
  "loyaltyAdmin.financeRecovery": "Результат запроса неизвестен. Повторите этот запрос перед новым доначислением.",
  "loyaltyAdmin.financeChanged": "Баланс изменился. Обновите данные и проверьте сумму.",
  "loyaltyAdmin.financeValidation": "Укажите положительную сумму с точностью курса, причину и будущую дату сгорания с причиной изменения.",
  "loyaltyAdmin.pointsUnit": "баллов",
  "loyaltyAdmin.refreshBalance": "Обновить баланс",
  "loyaltyAdmin.operationCREDIT": "Начисление",
  "loyaltyAdmin.operationRESERVE": "Резерв",
  "loyaltyAdmin.operationCOMMIT": "Списание",
  "loyaltyAdmin.operationRELEASE": "Снятие резерва",
  "loyaltyAdmin.operationREVERSE_CREDIT": "Отмена начисления",
  "loyaltyAdmin.operationREFUND_SPEND": "Возврат списания",
  "loyaltyAdmin.operationEXPIRE": "Сгорание",
  "loyaltyAdmin.coreCategoriesTitle": "Категории лояльности Core",
  "loyaltyAdmin.categoryReadOnlyNotice": "Только просмотр. Изменение категорий и выпуск карт через Core пока недоступны.",
  "loyaltyAdmin.issuerCategoryNotice": "Здесь показаны только категории этого мерчанта.",
  "loyaltyAdmin.currency": "Валюта",
  "loyaltyAdmin.giftKind": "Подарочная карта",
  "loyaltyAdmin.accrualRate": "Начисление, %",
  "loyaltyAdmin.discountRate": "Скидка, %",
  "loyaltyAdmin.giftLifetime": "Срок покупного номинала, месяцев",
  "loyaltyAdmin.notConfigured": "Требуется проверка настройки",
  "loyaltyAdmin.exclusionReferenceNotice": "Показано количество исключений; названия категорий товаров требуют сверки с каталогом.",
  "loyaltyAdmin.moreHistory": "Загрузить предыдущие версии",
  "loyaltyAdmin.transferTitle": "Импорт списка карт",
  "loyaltyAdmin.transferExportPairedUnavailable": "Экспорт пока недоступен: у этого owner есть карты с двумя категориями. Текущий формат файла потеряет вторую категорию и её баланс.",
  "loyaltyAdmin.transferExportTitle": "Экспорт живых карт и остатков",
  "loyaltyAdmin.transferExportNotice": "Создаёт доступный только финансовой роли снимок с доказуемыми точными кодами, всеми версиями категорий и порциями остатков, отдельными Gift/промо-обязательствами и отчётом начислений/списаний по мерчантам. Экспорт остановится, если точный код или pending-остаток нельзя подтвердить.",
  "loyaltyAdmin.transferExportXlsx": "Экспортировать живой XLSX",
  "loyaltyAdmin.transferExportCsv": "Экспортировать живой CSV",
  "loyaltyAdmin.transferExportPreparing": "Готовится owner-снимок…",
  "loyaltyAdmin.transferExportReady": "Проверенный снимок загружен.",
  "loyaltyAdmin.transferNotice": "Только предварительная проверка. Карты и балансы не изменяются; подтверждённый импорт пока недоступен.",
  "loyaltyAdmin.transferTemplateNotice": "Скачайте и заполните шаблон. Замените все примеры кодов, остатков, дат снимка и правил категорий своими данными.",
  "loyaltyAdmin.transferTemplateXlsx": "Шаблон XLSX",
  "loyaltyAdmin.transferTemplateCsv": "Шаблон CSV (ZIP)",
  "loyaltyAdmin.transferFormat": "Формат файлов",
  "loyaltyAdmin.transferFileLimit": "Суммарно до 2 МБ. Для CSV нужны все три файла, включая таблицу порций с заголовком, даже если порций нет.",
  "loyaltyAdmin.transferCheck": "Проверить файлы",
  "loyaltyAdmin.transferSave": "Сохранить пакет",
  "loyaltyAdmin.transferOpeningCheck": "Проверить начальные остатки",
  "loyaltyAdmin.transferOpeningChecked": "Расчёт начальных остатков проверен",
  "loyaltyAdmin.transferOpeningBlocked": "Расчёт начальных остатков заблокирован",
  "loyaltyAdmin.transferOpeningAt": "Момент расчёта",
  "loyaltyAdmin.transferOpeningNotice": "Только расчёт. Ещё нужны сопоставления, принятие исходных идентификаторов, согласования сроков и подтверждённое применение через журнал. Карты и балансы не изменены.",
  "loyaltyAdmin.transferOpeningSource": "Остаток снимка, мин. ед.",
  "loyaltyAdmin.transferOpeningExpired": "Сгорело после снимка, мин. ед.",
  "loyaltyAdmin.transferOpeningProjected": "Расчётный остаток, мин. ед.",
  "loyaltyAdmin.transferFutureSnapshot": "Дата снимка находится в будущем. Проверьте исходную дату и время.",
  "loyaltyAdmin.transferSaveNotice": "Сохранить зашифрованный снимок для последующей сверки. Это не создаёт карты, не подтверждает импорт и не изменяет балансы.",
  "loyaltyAdmin.transferSaved": "Пакет сохранён; импорт не применён. Номер",
  "loyaltyAdmin.transferDraftConflict": "Этот запрос сохранения уже связан с другими данными. Проверьте файлы заново перед созданием нового пакета.",
  "loyaltyAdmin.transferValid": "Проверка файлов пройдена",
  "loyaltyAdmin.transferInvalid": "Проверьте файлы и валюту назначения.",
  "loyaltyAdmin.transferErrors": "Ошибки",
  "loyaltyAdmin.transferWarnings": "Что нужно согласовать перед импортом",
  "loyaltyAdmin.transferMinorBalance": "Остаток (минимальные единицы валюты)",
  "loyaltyAdmin.transferSection_cards": "Карты",
  "loyaltyAdmin.transferSection_categories": "Версии категорий",
  "loyaltyAdmin.transferSection_lots": "Порции",
  "loyaltyAdmin.transferSection_package": "Пакет",
  "loyaltyAdmin.transferRow": "Строка",
  "loyaltyAdmin.transferDuplicate": "Повтор карты, кода, версии категории или порции.",
  "loyaltyAdmin.transferBalanceMismatch": "Сумма порций и долга не совпадает с остатком.",
  "loyaltyAdmin.transferMapping": "Подтвердите назначение карты, категорию и её версию перед импортом.",
  "loyaltyAdmin.transferOpening": "Согласуйте начальное сальдо и политику сроков.",
  "loyaltyAdmin.transferReservations": "Сверьте незавершённые резервы перед импортом.",
  "loyaltyAdmin.transferGift": "Применение покупного номинала пока недоступно.",
  "loyaltyAdmin.transferCheckRow": "Проверьте поля строки, типы и исходные даты.",
  "loyaltyAdmin.transferFile_cards": "CSV карт",
  "loyaltyAdmin.transferFile_categories": "CSV версий категорий",
  "loyaltyAdmin.transferFile_lots": "CSV порций",
  "loyaltyAdmin.transferFile_workbook": "Книга XLSX",
  "loyaltyAdmin.transferSessionChanged": "Сессия изменилась. Обновите страницу и выберите файлы заново.",
  "loyaltyAdmin.transferApplyTitle": "Подтвердить импорт",
  "loyaltyAdmin.transferApplyNotice": "Создаёт карты Coop и наблюдаемые начальные остатки, включая Gift с известными исходными порциями и сроками. Syrve и финансовый источник не меняются. Неизвестные сроки, резервы и сопоставление категорий требуют сверки.",
  "loyaltyAdmin.transferApplyPending": "Восстановить предыдущий запрос",
  "loyaltyAdmin.transferApplyIssuer": "У всех исходных карт одно выпускающее заведение; назначить выпускающим выбранного мерчанта.",
  "loyaltyAdmin.transferApplyBalances": "Проверены остатки, долг и исходные сроки порций.",
  "loyaltyAdmin.transferApply": "Импортировать",
  "loyaltyAdmin.transferApplyRetry": "Повторить исходный импорт",
  "loyaltyAdmin.transferApplyCancel": "Отменить непроведённый импорт",
  "loyaltyAdmin.transferApplied": "Карты импортированы",
  "loyaltyAdmin.transferApplyAborted": "Импорт отменён без создания остатков.",
  "loyaltyAdmin.transferApplyLookup": "Найти импортированные карты",
  "loyaltyAdmin.transferApplyDone": "Завершить",
  "loyaltyAdmin.transferApplyStorage": "Не удалось сохранить данные восстановления. Новый запрос не отправлен.",
  "loyaltyAdmin.transferApplyUnknown": "Результат неизвестен. Повторите исходный запрос или отмените его. Если импорт уже проведён, отмена сообщит об этом без изменения остатков.",
  "loyaltyAdmin.transferApplyMappingBlocked": "Сверьте выпускающие заведения или категории товаров. Отмените этот запрос перед исправлением пакета.",
  "loyaltyAdmin.transferApplyConflict": "Исходная карта или код уже существуют. Сверьте исходный импорт без повторного создания остатка.",
  "loyaltyAdmin.transferApplyUnsupported": "До импорта требуется сверка правил, сроков, резервов или категорий товаров.",
  "loyaltyAdmin.operationIMPORT_OPENING": "Начальное сальдо импорта",
  "loyaltyAdmin.transferApplyCategoryLimit": "В выбранном заведении поддерживается до 500 категорий. Отмените этот запрос и согласуйте пакет с существующими категориями.",
  "loyaltyAdmin.tasks": "Действия",
  "loyaltyAdmin.back": "Назад",
  "loyaltyAdmin.taskfind": "Найти карту",
  "loyaltyAdmin.taskcatalog": "Каталог карт",
  "loyaltyAdmin.taskissue": "Выпустить пустую карту",
  "loyaltyAdmin.taskcategories": "Категории",
  "loyaltyAdmin.taskgift": "Продать / пополнить Gift",
  "loyaltyAdmin.tasksource": "Настройки программы",
  "loyaltyAdmin.openCard": "Открыть карту",
  "loyaltyAdmin.loading": "Загрузка…",
  "loyaltyAdmin.balanceRead": "Остаток обновлён",
  "loyaltyAdmin.balanceDetails": "Подробности остатка",
  "loyaltyAdmin.creditUnavailable": "Ручное начисление временно недоступно. Обратитесь к администратору программы.",
  "loyaltyAdmin.issuerRequired": "Ручное начисление доступно у мерчанта выпуска.",
  "loyaltyAdmin.resumeCredit": "Продолжить начисление",
  "loyaltyAdmin.checkoutpoints": "баллов",
  "loyaltyAdmin.checkoutcardBalance": "Остаток карты",
  "loyaltyAdmin.checkoutavailableCardBalance": "Доступно по карте",
  "loyaltyAdmin.checkoutreservedCardBalance": "В резерве",
  "loyaltyAdmin.checkoutownerCardBalance": "Баланс карты владельца",
  "loyaltyAdmin.checkoutpartCalculation": "Расчёт выбранной части",
  "loyaltyAdmin.checkoutmaximumPart": "Максимум для этой части",
  "loyaltyAdmin.checkoutselectedValue": "Выбрано с карты",
  "loyaltyAdmin.checkoutavailableAfter": "Доступно после оплаты",
  "loyaltyAdmin.checkoutexpectedAccrual": "Ожидаемое начисление",
  "loyaltyAdmin.checkoutpriceDiscount": "Скидка по карте",
  "loyaltyAdmin.checkoutgiftUsed": "Оплачено Gift",
  "loyaltyAdmin.checkoutpromoUsed": "Списано бонусов",
  "loyaltyAdmin.checkoutpointsAccrued": "Начислено бонусов",
  "loyaltyAdmin.checkoutconfirmedPayment": "Подтверждённая оплата картой",
  "loyaltyAdmin.checkoutpaymentConfirmed": "Оплата картой подтверждена.",
  "loyaltyAdmin.checkoutcardUsed": "Списано с карты",
  "loyaltyAdmin.checkoutrecentHistory": "Последние операции карты",
  "loyaltyAdmin.checkoutnoOperations": "Операций по карте пока нет.",
  "loyaltyAdmin.checkoutlookupCode": "Код карты или QR",
  "loyaltyAdmin.checkoutreadCard": "Найти карту",
  "loyaltyAdmin.checkoutwithoutCard": "Продолжить без карты",
  "loyaltyAdmin.checkoutloyaltyCard": "Карта лояльности",
  "loyaltyAdmin.checkoutloyaltyCash": "Карта и наличные",
  "loyaltyAdmin.checkoutscanCardCheckout": "Сканировать карту",
  "loyaltyAdmin.checkoutnone": "Не использовать бонусы",
  "loyaltyAdmin.checkoutmaximum": "Использовать максимум",
  "loyaltyAdmin.checkoutcustom": "Указать бонусы",
  "loyaltyAdmin.checkoutamount": "Списать бонусов",
  "loyaltyAdmin.checkoutmoney": "Доплата за товары",
  "loyaltyAdmin.checkoutpointsDiscount": "Оплата бонусами",
  "loyaltyAdmin.checkoutprepayment": "Предоплата Gift",
  "loyaltyAdmin.checkoutgiftTitle": "Оплата Gift",
  "loyaltyAdmin.checkoutgiftNone": "Не использовать Gift",
  "loyaltyAdmin.checkoutgiftMaximum": "Использовать максимум Gift",
  "loyaltyAdmin.checkoutgiftCustom": "Указать сумму Gift",
  "loyaltyAdmin.checkoutpairedTitle": "Gift и бонусы",
  "loyaltyAdmin.checkoutpairedNone": "Не использовать карту",
  "loyaltyAdmin.checkoutpairedMaximum": "Использовать максимум карты",
  "loyaltyAdmin.checkoutpairedCustom": "Указать сумму",
  "loyaltyAdmin.checkoutconfirmGuest": "Согласовать и перейти к оплате",
  "loyaltyAdmin.checkoutfailedGuest": "Результат не подтверждён. Проверьте сохранённую оплату, прежде чем платить снова.",
  "loyaltyAdmin.checkoutexpired": "Расчёт истёк. Выберите сумму бонусов снова.",
  "loyaltyAdmin.checkoutgiftExpired": "Расчёт истёк. Выберите сумму Gift снова.",
  "loyaltyAdmin.checkoutpairedExpired": "Расчёт истёк. Выберите сумму снова.",
  "loyaltyAdmin.checkoutcashTitle": "Оплата картой",
  "loyaltyAdmin.checkoutcashGoods": "Наличные за товары",
  "loyaltyAdmin.checkoutcashConfirm": "Подтвердить получение наличных",
  "loyaltyAdmin.checkoutcashFailed": "Оплата не подтверждена. Проверьте сохранённую попытку, прежде чем принимать деньги снова.",
  "loyaltyAdmin.checkoutguestPending": "Сохранённая оплата требует проверки. Предъявите ту же карту. Тайм-аут не отменяет оплату.",
  "loyaltyAdmin.checkoutcashPending": "Оплата картой и наличными ожидает проверки. Предъявите ту же карту; проверьте результат перед повторным приёмом денег.",
  "loyaltyAdmin.checkoutresumeGuest": "Продолжить сохранённую оплату",
  "loyaltyAdmin.checkoutresumeCash": "Проверить предыдущую оплату",
  "loyaltyAdmin.checkoutcancelGuest": "Отменить незапущенную оплату",
  "loyaltyAdmin.checkoutcancelCash": "Отменить незапущенную оплату картой",
  "loyaltyAdmin.checkoutzeroGuest": "Подтвердить без доплаты",
  "loyaltyAdmin.checkoutpaymentUnavailable": "Оплата недоступна.",
  "loyaltyAdmin.checkoutsavedPaymentUnreadable": "Не удалось прочитать сохранённую оплату. Перед повторной оплатой обратитесь к сотруднику.",
  "loyaltyAdmin.checkoutrecoveryStorageUnavailable": "Хранилище восстановления оплаты недоступно. Перед повторной оплатой обратитесь к сотруднику.",
  "loyaltyAdmin.checkoutremainderUnconfirmed": "Остаток к оплате не подтверждён.",
  "loyaltyAdmin.checkoutcardBlocked": "Эта карта заблокирована.",
  "loyaltyAdmin.checkoutpaymentPendingResolution": "Оплата ещё не завершена. Снова проверьте сохранённую оплату.",
  "loyaltyAdmin.checkoutcancellationUnconfirmed": "Отмена не подтверждена.",
  "loyaltyAdmin.checkouttipRequiresPayment": "Уберите чаевые, чтобы подтвердить без доплаты, или используйте меньше бонусов.",
  "loyaltyAdmin.checkoutcalculationChanged": "Расчёт изменился.",
  "loyaltyAdmin.checkoutgiftAmountCurrency": "Сумма Gift ({currency})",
  "loyaltyAdmin.checkoutcardAmountCurrency": "Сумма с карты ({currency})",
  "loyaltyAdmin.checkoutworking": "Обработка…",
  "loyaltyAdmin.checkouttipLabel": "Чаевые",
  "loyaltyAdmin.checkoutcompleteGuestCount": "Укажите количество гостей до оплаты.",
  "loyaltyAdmin.checkoutinvalidPaymentAmount": "Рассчитанная сумма оплаты недопустима.",
  "loyaltyAdmin.checkoutcalculationChangedRetry": "Расчёт изменился. Снова выберите сумму бонусов.",
  "loyaltyAdmin.checkouthistoryImportOpening": "Импортирован начальный остаток",
  "loyaltyAdmin.checkouthistoryCredit": "Баланс пополнен",
  "loyaltyAdmin.checkouthistoryReserve": "Средства зарезервированы",
  "loyaltyAdmin.checkouthistoryRelease": "Резерв снят",
  "loyaltyAdmin.checkouthistoryPayment": "Оплата",
  "loyaltyAdmin.checkouthistoryPaymentPending": "Оплата ожидает подтверждения",
  "loyaltyAdmin.checkouthistoryPaymentCanceled": "Оплата отменена",
  "loyaltyAdmin.checkouthistoryPaymentReturned": "Средства за оплату возвращены",
  "loyaltyAdmin.checkouthistoryAccrualReversed": "Начисление отменено",
  "loyaltyAdmin.checkouthistoryExpired": "Срок действия средств истёк",
  "loyaltyAdmin.checkouthistoryOperation": "Операция по карте",
  "loyaltyAdmin.checkoutzeroCash": "Подтвердить без наличных за товары",
  "loyaltyAdmin.checkoutchoosePart": "Выберите доступную часть счёта для этой карты.",
  "loyaltyAdmin.checkoutchooseCashPart": "Выберите сумму в пределах остатка счёта.",
  "loyaltyAdmin.checkoutattached": "Карта привязана к текущему визиту.",
  "loyaltyAdmin.giftPresentSelectedCard": "Предъявите выбранную карту для продолжения.",
  "loyaltyAdmin.giftDifferentCard": "Это другая карта. Предъявите выбранную карту.",
  "loyaltyAdmin.ownerReportTitle": "Отчёт owner",
  "loyaltyAdmin.ownerReportNotice": "Показывает текущие обязательства Gift и Promo и движения карт за период. Конечная дата включена.",
  "loyaltyAdmin.ownerReportFrom": "С",
  "loyaltyAdmin.ownerReportTo": "По",
  "loyaltyAdmin.ownerReportMerchant": "Merchant движений",
  "loyaltyAdmin.ownerReportAllMerchants": "Все merchant этого owner",
  "loyaltyAdmin.ownerReportShow": "Показать отчёт",
  "loyaltyAdmin.ownerReportInvalidPeriod": "Выберите корректный период отчёта.",
  "loyaltyAdmin.ownerReportResult": "Результат отчёта",
  "loyaltyAdmin.ownerReportAsOf": "Обязательства на",
  "loyaltyAdmin.ownerReportObligations": "Текущие обязательства",
  "loyaltyAdmin.ownerReportActivity": "Движения за выбранный период",
  "loyaltyAdmin.ownerReportEmpty": "По выбранным условиям строк нет.",
  "loyaltyAdmin.ownerReportOutstanding": "Обязательство",
  "loyaltyAdmin.ownerReportAvailable": "Доступно",
  "loyaltyAdmin.ownerReportReserved": "Зарезервировано",
  "loyaltyAdmin.ownerReportDebt": "Долг",
  "loyaltyAdmin.ownerReportCredited": "Начислено",
  "loyaltyAdmin.ownerReportReversed": "Начисление отменено",
  "loyaltyAdmin.ownerReportRedeemed": "Списано",
  "loyaltyAdmin.ownerReportRefunded": "Списание возвращено",
  "loyaltyAdmin.ownerReportNet": "Чистое движение",
  "loyaltyAdmin.ownerReportMinorUnits": "Суммы показаны в минимальных единицах валюты.",
};
